/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/app_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/app_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  id: common.objectId,
  name: z.string(),
  platform: z
    .enum([
      "android",
      "android_china",
      "ios",
      "kepler",
      "kindle",
      "landing_page",
      "roku",
      "tvos",
      "web",
      "windows8",
    ])
    .nullable(),
  is_archived: z.boolean(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/app_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  id: common.objectId,
  name: z.string(),
  platform: z
    .enum([
      "android",
      "android_china",
      "ios",
      "kepler",
      "kindle",
      "landing_page",
      "roku",
      "tvos",
      "web",
      "windows8",
    ])
    .nullable(),
  is_archived: z.boolean(),
});
